import { render } from "./CampaignsDetail.vue?vue&type=template&id=02f09374&scoped=true"
import script from "./CampaignsDetail.vue?vue&type=script&lang=js"
export * from "./CampaignsDetail.vue?vue&type=script&lang=js"

import "./CampaignsDetail.vue?vue&type=style&index=0&id=02f09374&lang=scss&scoped=true"
import "./CampaignsDetail.vue?vue&type=style&index=1&id=02f09374&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f09374"]])

export default __exports__